import _overArg_default from "./_overArg.js";

//#region ../../node_modules/lodash-es/_getPrototype.js
/** Built-in value references. */
var getPrototype = _overArg_default(Object.getPrototypeOf, Object);
var _getPrototype_default = getPrototype;

//#endregion
export { _getPrototype_default as default };
//# sourceMappingURL=_getPrototype.js.map